import { useState, useEffect } from 'react';
import * as React from 'react';

//React Router
import { Navigate, useNavigate } from 'react-router-dom'
// tools and component for date picker
import dayjs from 'dayjs';

//MUI Components
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import EuroIcon from '@mui/icons-material/Euro';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { contratStepSlice } from "../../store/contratStepSlice.js";
import { contratSlice } from "../../store/contratSlice.js";
import { accessoiresSlice } from "../../store/accessoiresSlice.js";
import { checkCGVSlice } from "../../store/checkCGVSlice.js";
import { commentaireSlice } from "../../store/commentaireSlice.js";
import { dureeSlice } from "../../store/dureeSlice.js";
import { livraisonSlice } from "../../store/livraisonSlice.js";
import { panierSlice } from "../../store/panierSlice.js";
import { periodHeuresSlice } from "../../store/periodSlice.js";
import { periodDatesSlice } from "../../store/periodSlice.js";
import { userDataSlice } from "../../store/userDataSlice.js";

function ManagerNavBar({ idSpotLoc }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    function newContrat() {

        dispatch(contratSlice.actions.setContrat({})); //reset contrat
        dispatch(accessoiresSlice.actions.resetPanier()); //reset access
        dispatch(checkCGVSlice.actions.resetCGV()); //reset cvg
        dispatch(commentaireSlice.actions.setCommentaire("")); //reset commentaire
        dispatch(dureeSlice.actions.setDuree({})); //reset duree
        dispatch(livraisonSlice.actions.setLivraison({})); //reset livraiosn
        dispatch(panierSlice.actions.resetPanier()); //reset access

        //dispatch(periodHeuresSlice.actions.setHeure([0, 0])); //reset access
        //dispatch(periodDatesSlice.actions.setDate([dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])); //reset access

        dispatch(periodHeuresSlice.actions.setHeure({ heure: 0, index: 1 })); //reset access
        dispatch(periodHeuresSlice.actions.setHeure({ heure: 0, index: 2 })); //reset access

        dispatch(periodDatesSlice.actions.setDate({ jour: dayjs().format('YYYY-MM-DD'), index: 1 })); //reset access
        dispatch(periodDatesSlice.actions.setDate({ jour: dayjs().format('YYYY-MM-DD'), index: 2 })); //reset access


        dispatch(userDataSlice.actions.setUserData({
            found: false,
            id_client: 0,
            tel: "",
            email: "",
            prenom: "",
            nom: "",
            adresse: "",
            adresse_comp: "",
            cp: "",
            ville: "",
            pays: ""
        })); //reset userData

        dispatch(contratStepSlice.actions.goToContratStep(1)); //go to step 1

        navigate("/manager/contrat");

    }

    return (


        <div className="manager-navbar">
            <div className="manager-navbar-left">
                <HomeIcon
                    onClick={_ => navigate("/manager")}>
                </HomeIcon>

                <Button
                    variant="contained"
                    disabled={idSpotLoc === 0}

                    onClick={_ => newContrat()/* { dispatch(contratStepSlice.actions.goToContratStep(1)); 
                    navigate("/manager/contrat") } */}>
                    Contrat
            </Button>
                <Button
                    variant="contained"
                    disabled={idSpotLoc === 0}
                    onClick={_ => navigate("/manager/jour")}>
                    Planning jour
            </Button>
                <Button
                    variant="contained"
                    disabled={idSpotLoc === 0}
                    onClick={_ => navigate("/manager/semaine")}>
                    Planning Semaine
            </Button>



            </div>
            <div className="manager-navbar-right">
                <Button
                    variant="contained"
                    disabled={idSpotLoc === 0}
                    onClick={_ => navigate("/manager/stocks")}>
                    stocks
            </Button>
                <Button
                    variant="contained"
                    disabled={idSpotLoc === 0}
                    onClick={_ => navigate("/manager/search")}>
                    Recherche
            </Button>
                {idSpotLoc > 0 ?
                    <EuroIcon
                        onClick={_ => navigate("/manager/caisse")}>
                    </EuroIcon>
                    : null
                }


            </div>

        </div>

    );
}
export default ManagerNavBar